import { DatePicker, Input, Select } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardFilter } from "@/redux/slices/dashboard.slice";

const ComparisonTools = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.dashboard);
  const { isComparisonActive, quantity, operator, interval, window, comparisonPeriods } = filters || {};

  useEffect(() => {
    if (!comparisonPeriods?.length) {
      dispatch(
        setDashboardFilter({
          comparisonPeriods: [{ date: "", color: "#e81416" }],
        }),
      );
    }
  }, [comparisonPeriods]);
  const handleDateChange = (date, idx) => {
    const newComparisonPeriods = comparisonPeriods.map((data, innerIdx) => {
      let obj = { ...data };
      if (idx === innerIdx) obj.date = date;
      return obj;
    });
    dispatch(
      setDashboardFilter({
        comparisonPeriods: newComparisonPeriods,
      }),
    );
  };
  if (!isComparisonActive) return;
  return (
    <>
      <div className="col-md-12">
        <div className="comparison_tool_container">
          <div className="comparison_tool_item" style={{ width: "140px" }}>
            <label className="mt-2">Frequency</label>
            <Select
              size="large"
              style={{ width: "100%" }}
              placeholder="Select"
              value={interval || null}
              onChange={(value) =>
                dispatch(
                  setDashboardFilter({
                    interval: value,
                  }),
                )
              }
            >
              <Select.Option value="5">5 Min</Select.Option>
              <Select.Option value="10">10 Min</Select.Option>
              <Select.Option value="15">15 Min</Select.Option>
              <Select.Option value="30">30 Min</Select.Option>
              <Select.Option value="day">Daily</Select.Option>
              <Select.Option value="week">Weekly</Select.Option>
              <Select.Option value="month">Monthly</Select.Option>
              <Select.Option value="year">Yearly</Select.Option>
            </Select>
          </div>
          <div className="comparison_tool_item" style={{ width: "140px" }}>
            <label className="mt-2">Operator</label>
            <Select
              size="large"
              value={operator || null}
              onChange={(value) =>
                dispatch(
                  setDashboardFilter({
                    operator: value,
                  }),
                )
              }
              placeholder="Select"
              style={{ width: "100%" }}
            >
              <option value="max">Maximum</option>
              <option value="min">Minimum</option>
              <option value="avg">Average</option>
              <option value="sum">Sum</option>
            </Select>
          </div>
          <div className="comparison_tool_item" id="comparison_tool_window_item" style={{ width: "200px" }}>
            <label className="mt-2">Window</label>
            <Input
              size="large"
              addonBefore={
                <Select
                  size="large"
                  value={window || null}
                  onChange={(value) =>
                    dispatch(
                      setDashboardFilter({
                        window: value,
                      }),
                    )
                  }
                  style={{ width: "110px" }}
                  placeholder="Select"
                  options={[
                    { label: "Daily", value: "day" },
                    { label: "Weekly", value: "week" },
                    { label: "Monthly", value: "month" },
                    { label: "Yearly", value: "year" },
                  ]}
                />
              }
              placeholder="Enter Window Quantity"
              type="number"
              onChange={(value) =>
                dispatch(
                  setDashboardFilter({
                    quantity: value.target.value,
                  }),
                )
              }
              value={quantity}
              min="1"
            />
          </div>
          {comparisonPeriods?.map((item, idx) => (
            <div key={idx} className="comparison_tool_item" style={{ width: "140px" }}>
              <div className="d-flex align-items-center justify-content-between4">
                <label className="mt-2">{idx === 0 ? "Base Period" : "Period " + idx}</label>
                {idx !== 0 && (
                  <RxCrossCircled
                    className="ml-2"
                    color="red"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      let com = comparisonPeriods?.filter((item, innerIdx) => innerIdx !== idx);
                      dispatch(
                        setDashboardFilter({
                          comparisonPeriods: com,
                        }),
                      );
                    }}
                  />
                )}
              </div>

              <DatePicker
                className="form-control"
                placeholder={`Select`}
                disabledDate={(current) => current > moment()}
                onChange={(e, date) => handleDateChange(date, idx)}
                value={comparisonPeriods?.[idx]?.date ? dayjs(comparisonPeriods?.[idx]?.date) : null}
                style={{ borderColor: item.color }}
              />
            </div>
          ))}
          {comparisonPeriods?.length < 7 && (
            <div className="comparison_tool_item mt-2" style={{ width: "50px" }}>
              <FaPlus
                style={{
                  color: "#fff",
                  background: "rgb(25,135,84)",
                  marginTop: "34px",
                  marginBottom: "0 !important",
                  fontSize: "30px",
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                }}
                onClick={() => {
                  dispatch(
                    setDashboardFilter({
                      comparisonPeriods: [
                        ...comparisonPeriods,
                        { date: "", color: rainbowColors[comparisonPeriods.length] },
                      ],
                    }),
                  );
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

ComparisonTools.propTypes = {
  dashboardItems: PropTypes.array.isRequired,
  selectedTiles: PropTypes.array.isRequired,
};

export default ComparisonTools;

export const rainbowColors = ["#e81416", "#ffa500", "#4b369d", "#faeb36", "#79c314", "#487de7", "#70369d"];
